import { getAccessToken } from '../../../services/authService';
export async function subscriptionRequest(action = '', body) {
  const token = getAccessToken();
  if (!token) throw new Error('Please sign in again.');
  const response = await fetch(`${process.env.REACT_APP_DEV_API}/payment/subscription${action ? `/${action}` : ''}`, {
    method: action ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {const error=new Error(data.message || 'Subscription billing is not available.');error.code=data.code;throw error;}
  return data;
}